module.exports = __webpack_public_path__ + "static/media/medium.40950b20.svg";